import { array, literal, object, optional, string, union } from 'superstruct';

import { ListResourceDto } from '@adflow/shared/util-data';
import { PermissionsDto } from '@adflow/shared/util-permissions';
import { ViewRoleDto } from '@adflow/shared/util-roles';
import { adflowApiSchema } from '@adflow/shared/util-route-schema';
import { parsableInteger } from '@adflow/shared/util-superstruct';

import { AddUserDto } from './add-user.dto';
import { EditUserDto } from './edit-user.dto';
import { EditUserRolesDto } from './edit-user-roles.dto';
import { UserErrorDto } from './user-error.dto';
import { UserListFilterDto } from './user-list-filter.dto';
import {
	ViewUserDto,
	ViewUserInfoDto,
	ViewUserListedDto,
} from './view-user.dto';

const p = adflowApiSchema.prefix('users');

export const ListUsersWithRoles = p.get('', {
	req: object({
		query: UserListFilterDto,
	}),
	res: ListResourceDto(ViewUserListedDto),
});

export const ListUsers = p.get('options', {
	req: object({
		query: UserListFilterDto,
	}),
	res: ListResourceDto(ViewUserInfoDto),
});

export const GetUser = p.get(':userId', {
	req: object({
		params: object({ userId: parsableInteger() }),
	}),
	res: ViewUserDto,
});

export const GetUserPermissions = p.get(':userId/permissions', {
	req: object({
		params: object({ userId: parsableInteger() }),
	}),
	res: PermissionsDto,
});

export const GetUserRoles = p.get(':userId/roles', {
	req: object({
		params: object({ userId: parsableInteger() }),
	}),
	res: array(ViewRoleDto),
});

export const AddUser = p.post('', {
	req: object({
		body: AddUserDto,
	}),
	res: union([
		object({
			user: ViewUserDto,
			welcomeLink: optional(string()),
		}),
		UserErrorDto,
	]),
});

export const EditUser = p.patch(':userId', {
	req: object({
		params: object({ userId: parsableInteger() }),
		body: EditUserDto,
	}),
	res: union([ViewUserDto, UserErrorDto]),
});

// EditUser but for the current user
export const EditUserProfile = p.patch('profile', {
	req: object({
		body: EditUserDto,
	}),
	res: union([ViewUserDto, UserErrorDto]),
});

export const EditUserPermissions = p.patch(':userId/permissions', {
	req: object({
		params: object({ userId: parsableInteger() }),
		body: PermissionsDto,
	}),
	res: literal(undefined),
});

export const EditUserRoles = p.patch(':userId/roles', {
	req: object({
		params: object({ userId: parsableInteger() }),
		body: EditUserRolesDto,
	}),
	res: literal(undefined),
});

export const RefreshUser = p.post(':userId/refresh', {
	req: object({
		params: object({ userId: parsableInteger() }),
	}),
	res: literal(undefined),
});

export const UnlockUser = p.post(':userId/unlock', {
	req: object({
		params: object({ userId: parsableInteger() }),
	}),
	res: literal(undefined),
});

export const ArchiveUser = p.post(':userId/archive', {
	req: object({
		params: object({ userId: parsableInteger() }),
	}),
	res: literal(undefined),
});

export const DeleteUser = p.delete(':userId', {
	req: object({
		params: object({ userId: parsableInteger() }),
	}),
	res: literal(undefined),
});
